import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ConversationItem from "components/ConversationItem/ConversationItem";

import { getToken } from "services/token-service/token.service";
import { useGetConversations } from "services/hooks/useGetConversations";
import { useGetSearchedConversations } from "services/hooks/useGetSearchedConversations";

import "./PastChat.scss";

const PastChat = () => {
  const pastChatsListRef = useRef();
  const token = getToken();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [pastChats, setPastChats] = useState();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const searchString = urlParams.get("search");

  const { data: pastChatData, isFetched } = useGetConversations("past");
  const { mutate: searchConversations } = useGetSearchedConversations();

  useEffect(() => {
    isFetched && !searchString && setPastChats(pastChatData);
    isFetched && setHasMore(true);
  }, [isFetched, pastChatData, searchString]);

  useEffect(() => {
    const searchData = {
      category: "past",
      searchString,
      page: page || "1",
    };
    searchString &&
      searchConversations(searchData, {
        onSuccess: (res) => {
          setPastChats((prev) => (prev ? [...prev, ...res.data] : res.data));
          setHasMore(page < res.meta.last_page);
        },
      });
  }, [searchString, page, searchConversations]);

  useEffect(() => {
    page > 1 &&
      !searchString &&
      axios
        .get(
          `/api/admin/messages/conversations?category=pastChats&per_page=15&page=${page}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          setPastChats((prev) => [...prev, ...res.data.data]);
          setHasMore(page < res.data.meta.last_page);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [page, token]);

  const onScroll = () => {
    if (pastChatsListRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        pastChatsListRef.current;
      if (Math.round(scrollTop) + clientHeight >= scrollHeight) {
        if (hasMore) {
          setPage((prevPage) => prevPage + 1);
          setHasMore(false);
        }
      }
    }
  };

  return (
    <div className="PastChatsList" ref={pastChatsListRef} onScroll={onScroll}>
      {pastChats?.map((item) => {
        return (
          <ConversationItem
            conversationData={item}
            key={item.id}
            buttonType="read"
          />
        );
      })}
    </div>
  );
};

export default PastChat;
